import axios from 'axios';

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api' });

export interface Collection {
  id: number;
  name: string;
  description: string;
  color: string;
  deck_count: number;
  card_count: number;
  due_count: number;
  created_at: string;
}

export interface Deck {
  id: number;
  collection_id?: number;
  name: string;
  language_pair: 'en-vi' | 'ja-vi';
  description: string;
  card_count: number;
  due_count: number;
  created_at: string;
}

export interface Card {
  id: number;
  deck_id: number;
  front: string;
  back: string;
  reading?: string;
  example?: string;
  ease_factor: number;
  interval: number;
  repetitions: number;
  next_review: string;
}

export interface Stats {
  total_collections: number;
  total_decks: number;
  total_cards: number;
  due_today: number;
  reviewed_today: number;
}

export const getCollections = () => api.get<Collection[]>('/collections').then(r => r.data);
export const createCollection = (data: { name: string; description?: string; color?: string }) => api.post<Collection>('/collections', data).then(r => r.data);
export const updateCollection = (id: number, data: { name: string; description?: string; color?: string }) => api.put(`/collections/${id}`, data);
export const deleteCollection = (id: number) => api.delete(`/collections/${id}`);
export const getCollectionDecks = (id: number) => api.get<Deck[]>(`/collections/${id}/decks`).then(r => r.data);

export const getDecks = () => api.get<Deck[]>('/decks').then(r => r.data);
export const createDeck = (data: Partial<Deck> & { collection_id?: number }) => api.post<Deck>('/decks', data).then(r => r.data);
export const updateDeck = (id: number, data: Partial<Deck>) => api.put(`/decks/${id}`, data);
export const deleteDeck = (id: number) => api.delete(`/decks/${id}`);

export const getCards = (deckId: number) => api.get<Card[]>(`/decks/${deckId}/cards`).then(r => r.data);
export const createCard = (deckId: number, data: Partial<Card>) => api.post<Card>(`/decks/${deckId}/cards`, data).then(r => r.data);
export const updateCard = (id: number, data: Partial<Card>) => api.put(`/cards/${id}`, data);
export const deleteCard = (id: number) => api.delete(`/cards/${id}`);

export const getReviewCards = (deckId: number) => api.get<Card[]>(`/decks/${deckId}/review`).then(r => r.data);
export const getQuizCards = (deckId: number, limit = 10) => api.get<Card[]>(`/decks/${deckId}/quiz?limit=${limit}`).then(r => r.data);
export const reviewCard = (cardId: number, quality: number) => api.post(`/cards/${cardId}/review`, { quality }).then(r => r.data);

export const getStats = () => api.get<Stats>('/stats').then(r => r.data);

export interface GeneratedCard {
  front: string;
  back: string;
  reading?: string | null;
  example?: string | null;
}

export const aiGenerateCards = (
  deckId: number,
  data: { text: string; language_pair: string }
) => api.post<{ cards: GeneratedCard[] }>(`/decks/${deckId}/ai-generate`, data).then(r => r.data);
